
















import vue from "vue";
import {
  TerratalkLiveActionNames,
  TerratalkLiveGetterNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

export default vue.extend({
  name: "TerratalkLiveSessionEndedAlert",

  methods: {
    closeModal() {
      this.$store.dispatch(
        `${TerratalkLiveNamespace}/${TerratalkLiveActionNames.HIDE_SESSION_ENDED_MODAL}`
      );
    }
  },

  computed: {
    activeSession() {
      return this.$store.getters[
        `${TerratalkLiveNamespace}/${TerratalkLiveGetterNames.ACTIVE_SESSION}`
      ];
    },

    open() {
      return this.$store.state.terratalkLive.modals.sessionEnded.open;
    },

    selectedAlias() {
      return this.$store.state.user.selectedAlias;
    }
  }
});
